// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Removed unused Reducers'
// Modified Date : 23-08-2025
import { docodeHexResponse } from '../../../_common/common.utils';
import journalTransactionTypes from './journal-transaction.types';

const INITIAL_STATE = {
	// voucher Count
	voucherCountResp: null,
	voucherCountListArr: {},
	// get particular account details for edit
	particularAccountDetailsResp: null,
	particularAccountDetailsArr: [],
	// create journal entry
	createJournalEntryResp: null,
	createJournalEntryArr: [],
	// update journal entry
	updateJournalEntryResp: null,
	updateJournalEntryArr: [],
};

const journalTransactionReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH JOURNAL TRANSACTIONS VOUCHER COUNT START *********************** */
		case journalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_SUCCESS:
			return {
				...state,
				voucherCountResp: action.payload,
				voucherCountListArr: docodeHexResponse(
					action.payload,
					'GetJournalTransactionVoucherCountKey',
				),
			};

		case journalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_FAILURE:
			return {
				...state,
				voucherCountResp: action.payload,
			};

		case journalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_CHANGED:
			return { ...state, voucherCountResp: null };

		case journalTransactionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_RESET:
			return {
				...state,
				voucherCountResp: null,
			};
		/** ***************** FETCH JOURNAL TRANSACTIONS VOUCHER COUNT END *********************** */

		/** ***************** FETCH PARTICULAR ACCOUNT DETAILS START *********************** */
		case journalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_SUCCESS:
			return {
				...state,
				particularAccountDetailsResp: action.payload,
				particularAccountDetailsArr: docodeHexResponse(
					action.payload,
					'GetParticularAccountDetailsKey',
				),
			};

		case journalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_FAILURE:
			return {
				...state,
				particularAccountDetailsResp: action.payload,
			};

		case journalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				particularAccountDetailsResp: null,
			};

		case journalTransactionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_RESET:
			return {
				...state,
				particularAccountDetailsResp: null,
			};
		/** ***************** FETCH PARTICULAR ACCOUNT DETAILS END *********************** */

		/** ***************** CREATE JOURNAL ENTRY START *********************** */
		case journalTransactionTypes.CREATE_JOURNAL_ENTRY_SUCCESS:
			return {
				...state,
				createJournalEntryResp: action.payload,
				createJournalEntryArr: docodeHexResponse(action.payload, 'CreateJournalEntryKey'),
			};

		case journalTransactionTypes.CREATE_JOURNAL_ENTRY_FAILURE:
			return {
				...state,
				createJournalEntryResp: action.payload,
			};

		case journalTransactionTypes.CREATE_JOURNAL_ENTRY_RESPONSE_CHANGED:
			return {
				...state,
				createJournalEntryResp: null,
			};

		case journalTransactionTypes.CREATE_JOURNAL_ENTRY_RESPONSE_RESET:
			return {
				...state,
				createJournalEntryResp: null,
			};
		/** ***************** CREATE JOURNAL ENTRY END *********************** */

		/** ***************** UPDATE JOURNAL ENTRY START *********************** */
		case journalTransactionTypes.UPDATE_JOURNAL_ENTRY_SUCCESS:
			return {
				...state,
				updateJournalEntryResp: action.payload,
				updateJournalEntryArr: docodeHexResponse(
					action.payload,
					'UpdateJournalTransactionKey',
				),
			};

		case journalTransactionTypes.UPDATE_JOURNAL_ENTRY_FAILURE:
			return {
				...state,
				updateJournalEntryResp: action.payload,
			};

		case journalTransactionTypes.UPDATE_JOURNAL_ENTRY_RESPONSE_CHANGED:
			return {
				...state,
				updateJournalEntryResp: null,
			};

		case journalTransactionTypes.UPDATE_JOURNAL_ENTRY_RESPONSE_RESET:
			return {
				...state,
				updateJournalEntryResp: null,
			};
		/** ***************** UPDATE JOURNAL ENTRY END *********************** */

		default:
			return state;
	}
};
export default journalTransactionReducer;
